import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
    getAcceptanceRuleLookups,
    getAcceptanceRuleLookupsFailure,
    getAcceptanceRuleLookupsSuccess,
    setAcceptanceRuleLookupsIsLoadingFlag
} from 'src/app/compliance/store/actions/compliance-requirement-descriptions.actions';
import { AcceptanceRulesClient } from '../../api/acceptance-rules-client.service';
import { AcceptanceRuleLookupsDto } from '../../api/models/acceptance-rule-lookups-dto.model';
import { ComplianceState } from '../state/compliance.state';

@Injectable()
export class ComplianceRequirementDescriptionsEffects {
    getAcceptanceRuleLookups$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(getAcceptanceRuleLookups),
            switchMap((action) => {
                this._store.dispatch(setAcceptanceRuleLookupsIsLoadingFlag({ isLoading: true }));
                return this._acceptanceRulesClient.getAcceptanceRuleLookups(action.documentTypeId, action.displayTextTarget, action.isSmartDescriptionsEnabled).pipe(
                    map((result: AcceptanceRuleLookupsDto) => {
                        this._store.dispatch(setAcceptanceRuleLookupsIsLoadingFlag({ isLoading: false }));
                        return getAcceptanceRuleLookupsSuccess({ acceptanceRuleLookups: result });
                    }),
                    catchError((result: unknown) => of(getAcceptanceRuleLookupsFailure({ error: result })))
                );
            })
        );
    });

    constructor(
        private readonly _actions$: Actions,
        private readonly _acceptanceRulesClient: AcceptanceRulesClient,
        private readonly _store: Store<ComplianceState>
    ) {}
}
